import styled from "styled-components";

export const AnnouncementContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: ${({ borderRadius }) => borderRadius}px;
  border: 0.71px solid ${({ theme }) => theme.border.black10};
  background: ${({ theme }) => theme.bg.card};
  padding: 16px;
  box-shadow: 0px 0.832px 4.159px 0px rgba(63, 65, 66, 0.2);
  cursor: ${({ hasLink }) => (hasLink ? "pointer" : "default")};
`;

export const AnnouncementContentContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ isList }) =>
    isList ? "300px 1fr" : "repeat(2, 1fr)"};
  gap: 15px;
`;

export const AnnouncementInformationsContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > div:last-child {
    padding-bottom: 0;
  }
`;

export const AnnouncementCover = styled.img`
  object-fit: cover;
  height: ${({ isList }) => (isList ? "220px" : "180px")};
  width: 100%;
  border-radius: ${({ borderRadius }) => borderRadius - 6}px;
  object-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
`;

export const AnnoucementDateContainer = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 13px;
  display: grid;
  place-content: center;
  height: ${({ isList }) => (isList ? "220px" : "180px")};
`;

export const AnnouncementDate = styled.div`
  width: 65px;
  height: 65px;
  background: ${({ backgroundColor }) => backgroundColor}CC;
  color: ${({ theme }) => theme.text.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  font-weight: 600;
`;

export const AnnouncementHeading = styled.h1`
  margin: 0;
  font-size: ${({ isList }) => (isList ? "33px" : "18px")};
  font-weight: 500;
  color: ${({ theme }) => (theme.name === "dark" ? "#2A2A2A" : "#121212")};
`;

export const AnnouncementParticipantsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AnnouncementHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const AnnouncementInformationContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.border.black10};
  padding-block: 8px;
`;

export const AnnouncementInformationSpan = styled.span`
  color: ${({ theme }) => theme.border.black50};
  font-size: 14px;
`;

export const AnnouncementAttendButton = styled.div`
  display: inline-flex;
  padding: 4px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 24px;
  background: ${({ bgClr, textClr, inverse }) => (inverse ? textClr : bgClr)};
  color: ${({ bgClr, textClr, inverse }) => (inverse ? bgClr : textClr)};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.202px;
  letter-spacing: -0.5px;
  min-height: 32px;
  cursor: pointer;
`;
